import { JSX } from "react";
import { Document, Page, View } from "@react-pdf/renderer";
import React from "react";
import type { Resume } from "lib/redux/types";
import { DEFAULT_FONT_COLOR } from "lib/redux/settingsSlice";
import type { Settings, ShowForm } from "lib/redux/settingsSlice";
import { spacing, styles } from "../ResumePDF/styles";
import { FontSizeProvider } from "../ResumePDF/FontSizeContext";
import Profile from "./Profile";
import ProfileOverview from "./ProfileOverview";
import Skills from "./Skills";
import Languages from "./Languages";
import Education from "./Education";
import WorkExperience from "./WorkExperience";
import Project from "./Project";
import Certificate from "./Certificate";
import Award from "./Award";
import Custom from "./Custom";
import Summary from "./Summary";
const TemplateEleven = ({
  resume,
  settings,
  isPDF = false,
}: {
  resume: Resume;
  settings: Settings;
  isPDF?: boolean;
}) => {
  const {
    profile,
    workExperiences,
    educations,
    projects,
    skills,
    certifications,
    languages,
    awards,
    custom,
  } = resume;
  const { name } = profile;
  const {
    fontFamily,
    fontSize,
    documentSize,
    formToHeading,
    formToShow,
    formsOrder,
    showBulletPoints,
  } = settings;
  const themeColor = settings.themeColor || DEFAULT_FONT_COLOR;

  const showFormsOrder = formsOrder.filter((form) => formToShow[form]);
  const formTypeToComponent: { [type in ShowForm]: () => JSX.Element } = {
    workExperiences: () => (
      <WorkExperience
        heading={formToHeading["workExperiences"]}
        workExperiences={workExperiences}
        themeColor={themeColor}
      />
    ),
    educations: () => (
      <Education
        heading={formToHeading["educations"]}
        educations={educations}
        themeColor={themeColor}
        showBulletPoints={showBulletPoints["educations"]}
      />
    ),
    projects: () => (
      <Project
        heading={formToHeading["projects"]}
        projects={projects}
        themeColor={themeColor}
        isPDF={isPDF}
      />
    ),
    skills: () => (
      <Skills
        heading={formToHeading["skills"]}
        skills={skills}
        themeColor={themeColor}
        showBulletPoints={showBulletPoints["skills"]}
      />
    ),
    certifications: () => (
      <Certificate
        heading={formToHeading["certifications"]}
        certifications={certifications}
        themeColor={themeColor}
        isPDF={isPDF}
      />
    ),
    languages: () => (
      <Languages
        heading={formToHeading["languages"]}
        languages={languages}
        themeColor={themeColor}
      />
    ),
    awards: () => (
      <Award
        heading={formToHeading["awards"]}
        awards={awards}
        themeColor={themeColor}
        isPDF={isPDF}
      />
    ),
    custom: () => (
      <Custom
        heading={formToHeading["custom"]}
        custom={custom}
        themeColor={themeColor}
        showBulletPoints={showBulletPoints["custom"]}
      />
    ),
  };

  return (
    <Document title={`${name} Resume`} author={name} producer={"OpenResume"}>
      <Page
        size={documentSize === "A4" ? "A4" : "LETTER"}
        style={{
          ...styles.flexCol,
          color: DEFAULT_FONT_COLOR,
          fontFamily,
          fontSize: fontSize + "pt",
          // backgroundColor:"red",
          padding: "10pt",
        }}
      >
        <FontSizeProvider fontSize={fontSize}>
          <View style={{ paddingTop: `${spacing[5]}` }} fixed></View>

          <View
            style={{
              ...styles.flexCol,
              padding: `${spacing[0]} ${spacing[10]}`,
            }}
          >
            <Profile profile={profile} themeColor={themeColor} isPDF={isPDF} />

            {profile.summary && (
              <Summary
                summary={profile.summary}
                themeColor={themeColor}
                heading="PROFILE"
              />
            )}
            {showFormsOrder.map((form) => {
              const Component = formTypeToComponent[form];
              return <Component key={form} />;
            })}
          </View>
          <View
            style={{
              paddingBottom: `${spacing[5]}`,
            }}
            fixed
          ></View>
        </FontSizeProvider>
      </Page>
    </Document>
  );
};

export default TemplateEleven;
